export enum deviceSettingsTabs {
  tamperResistance = 'Tamper Resistance',
  startMode = 'Start Mode',
  switches = 'Switches',
}

export interface ConfigurationState {
  endofDayReportTime: {
    desiredSetting: {
      endOfDay: string;
    };
  };
  locator: {
    desiredSetting: {
      reportingInterval: number | null;
      lowTempThreshold: number | null;
      highTempThreshold: number | null;
      motionDetectionThreshold: number | null;
      enableMotionDetect: boolean;
    };
  };
}

export enum ConfigurationActionNames {
  SET_DEVICE_CONFIGURATION = 'SET_DEVICE_CONFIGURATION',
}

interface SetDeviceConfiguration {
  type: typeof ConfigurationActionNames.SET_DEVICE_CONFIGURATION;
  payload: ConfigurationState;
}

export type ConfigurationActionTypes = SetDeviceConfiguration;
